"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpendingCategoryTypeCode = exports.CreditCardSigningAction = exports.AccountStatementFileType = exports.AccountStatementTransactionType = exports.TransactionAdvancedSearchOption = exports.TransactionsPeriodFilter = exports.CreditCardSecretType = void 0;
var CreditCardSecretType;
(function (CreditCardSecretType) {
    CreditCardSecretType["PIN"] = "PIN";
    CreditCardSecretType["PAN"] = "PAN";
    CreditCardSecretType["CVV"] = "CVV";
})(CreditCardSecretType || (exports.CreditCardSecretType = CreditCardSecretType = {}));
var TransactionsPeriodFilter;
(function (TransactionsPeriodFilter) {
    TransactionsPeriodFilter["Today"] = "TODAY";
    TransactionsPeriodFilter["Yesterday"] = "YESTERDAY";
    TransactionsPeriodFilter["CurrentWeek"] = "CURRENT_WEEK";
    TransactionsPeriodFilter["PreviousWeek"] = "PREVIOUS_WEEK";
    TransactionsPeriodFilter["CurrentMonth"] = "CURRENT_MONTH";
    TransactionsPeriodFilter["PreviousMonth"] = "PREVIOUS_MONTH";
    TransactionsPeriodFilter["CurrentYear"] = "CURRENT_YEAR";
})(TransactionsPeriodFilter || (exports.TransactionsPeriodFilter = TransactionsPeriodFilter = {}));
var TransactionAdvancedSearchOption;
(function (TransactionAdvancedSearchOption) {
    TransactionAdvancedSearchOption["AnyFieldContains"] = "AnyFieldContains";
    TransactionAdvancedSearchOption["NoFieldContains"] = "NoFieldContains";
    TransactionAdvancedSearchOption["Amount"] = "Amount";
    TransactionAdvancedSearchOption["AmountLessThanEqualTo"] = "AmountLessThanEqualTo";
    TransactionAdvancedSearchOption["AmountGreaterThanEqualTo"] = "AmountGreaterThanEqualTo";
    TransactionAdvancedSearchOption["AccountNumber"] = "AccountNumber";
    TransactionAdvancedSearchOption["DetailsContains"] = "DetailsContains";
})(TransactionAdvancedSearchOption || (exports.TransactionAdvancedSearchOption = TransactionAdvancedSearchOption = {}));
var AccountStatementTransactionType;
(function (AccountStatementTransactionType) {
    AccountStatementTransactionType["Credit"] = "CREDIT";
    AccountStatementTransactionType["Debit"] = "DEBIT";
    AccountStatementTransactionType["Reservation"] = "RESERVATION";
})(AccountStatementTransactionType || (exports.AccountStatementTransactionType = AccountStatementTransactionType = {}));
var AccountStatementFileType;
(function (AccountStatementFileType) {
    AccountStatementFileType["PDF"] = "PDF";
    AccountStatementFileType["CSV"] = "CSV";
    AccountStatementFileType["ASICE"] = "ASICE";
})(AccountStatementFileType || (exports.AccountStatementFileType = AccountStatementFileType = {}));
var CreditCardSigningAction;
(function (CreditCardSigningAction) {
    CreditCardSigningAction["Activate"] = "activate";
    CreditCardSigningAction["Replace"] = "replace";
    CreditCardSigningAction["Unblock"] = "unblock";
    CreditCardSigningAction["ViewPin"] = "view-pin";
    CreditCardSigningAction["ViewCvvAndPan"] = "view-cvv-and-pan";
    CreditCardSigningAction["UpdateLimits"] = "update-limits";
})(CreditCardSigningAction || (exports.CreditCardSigningAction = CreditCardSigningAction = {}));
var SpendingCategoryTypeCode;
(function (SpendingCategoryTypeCode) {
    SpendingCategoryTypeCode["Online"] = "ONLINE";
    SpendingCategoryTypeCode["Contactless"] = "CONTACTLESS";
    SpendingCategoryTypeCode["Regular"] = "REGULAR";
    SpendingCategoryTypeCode["Cash"] = "CASH";
})(SpendingCategoryTypeCode || (exports.SpendingCategoryTypeCode = SpendingCategoryTypeCode = {}));
